export var ListEntityType;
(function (ListEntityType) {
    ListEntityType["STUDY"] = "study";
    ListEntityType["ORGANISATION"] = "organisation";
    ListEntityType["SCHOLARSHIP"] = "scholarship";
    ListEntityType["CAREER"] = "career";
})(ListEntityType || (ListEntityType = {}));
